let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gHrjT")).then(() => parcelRequire('4BqrB'));